export const ADD_ORDER='Add order'
export const DELETE_ORDER='Delete order'
export const UPDATE_ORDER='Update order'
export const CLEAR_ORDERS='Clear orders'
